import { ArrowRight } from "@mui/icons-material";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { Dispatch, ReactNode, SetStateAction } from "react";

export function EntryTableExpander({
  text,
  expanded,
  setExpanded,
}: {
  text: ReactNode;
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <div
      className="flex items-center text-sm cursor-pointer"
      onClick={() => {
        setExpanded(!expanded);
      }}>
      {text}
      {expanded ? <ArrowDropDown /> : <ArrowRight />}
    </div>
  );
}
